import { Skeleton, SkeletonProps } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ReactComponent as AiFillNewSvg } from 'assets/svgs/ai-fill-new.svg';

const Wrapper = styled.div`
  padding: var(--spacing-03);
  display: flex;
  gap: var(--spacing-03);
  background: linear-gradient(90.71deg, #ebf0ff 0.61%, #e8fff7 119.53%);
  border-radius: var(--border-radius-small);
  width: 100%;
`;

const StyledSkeleton = styled(Skeleton)`
  width: 50%;
`;

const PlaceholderWrapper = styled.div`
  .ant-skeleton-content .ant-skeleton-paragraph > li {
    background: linear-gradient(
      90deg,
      rgba(15, 98, 254, 0.2) 0%,
      rgba(9, 152, 116, 0.2) 97.98%
    );
    background-size: 400% 100%;
    animation: ant-skeleton-loading 0.7s infinite alternate;
    width: 100%;
  }
`;

const PlaceholderText = styled.div`
  color: var(--gray-70);
  font-style: italic;
  margin-bottom: var(--spacing-03);
  width: 60%;
`;

// We can't delay the animation between iterations. So using the approach given in this article
// https://css-tricks.com/css-keyframe-animation-delay-iterations
const IconPlaceholder = styled.div`
  svg {
    animation: ai-fill-animation 1.4s infinite ease-in-out;
  }

  @keyframes ai-fill-animation {
    28% {
      transform: scale(1);
    }
    71% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const AiFillPlaceholderSkeleton = ({
  hideSkeleton,
  skeletonProps,
}: {
  hideSkeleton?: boolean;
  skeletonProps?: SkeletonProps;
}) => {
  return (
    <Wrapper>
      <IconPlaceholder>
        <AiFillNewSvg />
      </IconPlaceholder>
      <PlaceholderWrapper>
        <PlaceholderText>
          <FormattedMessage id="generating_with_ai" />
        </PlaceholderText>
        {hideSkeleton ? null : (
          <StyledSkeleton
            active
            title={false}
            paragraph={{ rows: 5, width: ['60%', '50%', '100%', '60%', '50%'] }}
            {...skeletonProps}
          />
        )}
      </PlaceholderWrapper>
    </Wrapper>
  );
};
